import AsyncStorage from "@react-native-async-storage/async-storage";
import { createAsyncStoragePersister } from "@tanstack/query-async-storage-persister";
import type { PersistQueryClientOptions } from "@tanstack/react-query-persist-client";

const asyncStoragePersister = createAsyncStoragePersister({
  storage: AsyncStorage,
  key: "taskscribe:query-cache",
});

/**
 * Persist the whole cache. A guest's tasks live only here until they sign up;
 * a signed-in user's cache is kept so a cold start works offline. The mutation
 * cache is persisted too, so a signed-in write made offline survives an app
 * restart and is replayed by `resumePausedMutations()`.
 */
export const persistOptions: Omit<PersistQueryClientOptions, "queryClient"> = {
  persister: asyncStoragePersister,
  // A guest's tasks have no server copy until sign-up, so the cache must
  // never be aged out from under them. Freshness for signed-in users comes
  // from staleTime + mutation invalidation, not from discarding data.
  maxAge: Infinity,
  dehydrateOptions: {
    shouldDehydrateQuery: () => true,
    shouldDehydrateMutation: () => true,
  },
};
